"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShorthandSymbol = void 0;
exports.ShorthandSymbol = Symbol();
//# sourceMappingURL=shared.js.map